module.exports = __webpack_public_path__ + "static/img/preview-07.75b47950.webp";